(function () {
  document.documentElement.classList.add('mt-js');

  var observer = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  var galleryApi = null;

  function initGallery(root) {
    var wrap = (root || document).querySelector('[data-mt-gallery]');
    if (!wrap) return;
    var stage = wrap.querySelector('.mt-gal__main');
    var track = wrap.querySelector('[data-mt-track]');
    var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-mt-thumb]'));
    if (!stage || !track || !thumbs.length) return;

    var n = track.children.length;
    var current = 0;
    for (var k = 0; k < thumbs.length; k++) { if (thumbs[k].classList.contains('is-active')) current = k; }
    var dots = null, settleTimer = null;

    function width() { return track.clientWidth || 1; }

    function paint(i) {
      current = i;
      thumbs.forEach(function (b, idx) { b.classList.toggle('is-active', idx === i); });
      if (dots) Array.prototype.forEach.call(dots.children, function (d, idx) { d.classList.toggle('is-on', idx === i); });
      // Mover SOLO la tira de miniaturas (nunca la página) para que la activa quede a la vista
      var btn = thumbs[i], cont = btn.parentNode;
      if (cont && cont.scrollWidth > cont.clientWidth + 2) {
        var left = btn.offsetLeft - (cont.clientWidth - btn.offsetWidth) / 2;
        if (cont.scrollTo) cont.scrollTo({ left: left, behavior: 'smooth' }); else cont.scrollLeft = left;
      }
    }

    function scrollToIndex(i, smooth) {
      var left = i * width();
      if (Math.abs(track.scrollLeft - left) < 1) return;
      if (track.scrollTo) track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      else track.scrollLeft = left;
    }

    function goTo(i, withVariant) {
      i = (i + n) % n;
      if (i === current) return;
      paint(i);
      scrollToIndex(i, true);
      if (withVariant) {
        var vid = thumbs[i] && thumbs[i].getAttribute('data-variant-id');
        if (vid) selectVariantById(vid);
      }
    }

    // El usuario desliza: cuando la foto se asienta, se actualiza miniatura, puntos y color
    function settle() {
      var idx = Math.round(track.scrollLeft / width());
      idx = Math.max(0, Math.min(n - 1, idx));
      if (idx !== current) {
        paint(idx);
        var vid = thumbs[idx] && thumbs[idx].getAttribute('data-variant-id');
        if (vid) selectVariantById(vid);
      }
    }
    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 120);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { clearTimeout(settleTimer); settle(); });

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { goTo(i, true); });
    });

    if (n > 1) {
      dots = document.createElement('div');
      dots.className = 'mt-gal__dots';
      dots.setAttribute('aria-hidden', 'true');
      for (var d = 0; d < n; d++) dots.appendChild(document.createElement('span'));
      stage.appendChild(dots);

      ['prev', 'next'].forEach(function (dir) {
        var a = document.createElement('button');
        a.type = 'button';
        a.className = 'mt-gal__arrow mt-gal__arrow--' + dir;
        a.setAttribute('aria-label', dir === 'prev' ? 'Foto anterior' : 'Foto siguiente');
        a.textContent = dir === 'prev' ? '\u2039' : '\u203A';
        a.addEventListener('click', function () { goTo(current + (dir === 'prev' ? -1 : 1), true); });
        stage.appendChild(a);
      });
    }

    paint(current);
    scrollToIndex(current, false);
    window.addEventListener('resize', function () { scrollToIndex(current, false); });

    // Para que al elegir un color (o tocar una miniatura desde fuera) la galería se mueva sola
    galleryApi = {
      selectThumb: function (btn) {
        var i = thumbs.indexOf(btn);
        if (i > -1 && i !== current) { paint(i); scrollToIndex(i, true); }
      }
    };
  }

  // Al cambiar de foto, marca el color (variante) ligado a esa foto.
  function selectVariantById(id) {
    var jsonEl = document.querySelector('[data-mt-variants]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var v = variants.find(function (x) { return String(x.id) === String(id); });
    if (!v) return;
    var scope = document.querySelector('[data-mt-form-root]') || document;
    var changed = false, lastInput = null;
    scope.querySelectorAll('.mt-opt').forEach(function (fs, i) {
      fs.querySelectorAll('input[type=radio]').forEach(function (r) {
        if (r.value === v.options[i] && !r.checked) { r.checked = true; changed = true; lastInput = r; }
      });
    });
    if (changed && lastInput) lastInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initVariants(root) {
    var form = (root || document).querySelector('[data-mt-form]');
    if (!form) return;
    var jsonEl = form.querySelector('[data-mt-variants]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var scope = form.closest('[data-mt-form-root]') || form;
    var idInput = form.querySelector('input[name=id]');
    var priceEl = form.querySelector('[data-mt-price]');
    var btn = form.querySelector('[data-mt-submit]');
    var labelAdd = btn.getAttribute('data-label-add');
    var labelSold = btn.getAttribute('data-label-sold');
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'COP';
    function fmt(cents) {
      if (currency === 'COP') {
        return '$' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }
    function baseUrl(u) {
      return (u || '').replace(/^https?:/, '').replace(/^\/\//, '').split('?')[0].replace(/_\d+x\d*(?=\.\w+$)/, '');
    }
    function showVariantImage(v) {
      var src = (v.featured_image && v.featured_image.src) || (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src);
      if (!src || !galleryApi) return;
      var wrap = document.querySelector('[data-mt-gallery]');
      if (!wrap) return;
      var base = baseUrl(src), hit = null;
      wrap.querySelectorAll('[data-mt-thumb]').forEach(function (t) { if (baseUrl(t.getAttribute('data-src')) === base) hit = t; });
      if (hit) galleryApi.selectThumb(hit);
    }
    function update() {
      var chosen = [];
      scope.querySelectorAll('.mt-opt').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        chosen.push(c ? c.value : null);
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { btn.disabled = true; btn.textContent = labelSold; return; }
      idInput.value = v.id;
      var prepaidWrap = document.querySelector('[data-mt-prepaid-wrap]');
      var prepaidLink = document.querySelector('[data-mt-prepaid]');
      if (prepaidLink) { prepaidLink.setAttribute('data-variant', v.id); syncPrepaid(); }
      if (prepaidWrap) prepaidWrap.hidden = !v.available;
      showVariantImage(v);
      if (priceEl) priceEl.textContent = fmt(v.price);
      var cmp = form.querySelector('[data-mt-compare]');
      var cmpText = cmp && cmp.querySelector('s');
      var save = form.querySelector('[data-mt-save]');
      var hasAnchor = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !hasAnchor; if (hasAnchor && cmpText) cmpText.textContent = fmt(v.compare_at_price); }
      if (save) {
        save.hidden = !hasAnchor;
        if (hasAnchor) {
          var diff = v.compare_at_price - v.price;
          var pct = Math.floor(diff * 100 / v.compare_at_price);
          var amountEl = document.createElement('span');
          amountEl.className = 'mt-save__amount';
          amountEl.textContent = (save.getAttribute('data-save-label') || 'Ahorras') + ' ' + fmt(diff);
          var pctEl = document.createElement('span');
          pctEl.className = 'mt-save__pct';
          pctEl.textContent = pct + '% OFF';
          while (save.firstChild) save.removeChild(save.firstChild);
          save.appendChild(amountEl);
          save.appendChild(pctEl);
        }
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? labelAdd : labelSold;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      syncSticky();
    }
    scope.querySelectorAll('.mt-opt input').forEach(function (i) { i.addEventListener('change', update); });
  }

  function syncPrepaid() {
    var link = document.querySelector('[data-mt-prepaid]');
    if (!link) return;
    var input = document.querySelector('[data-mt-qty-input]');
    var n = input ? parseInt(input.value, 10) : 1;
    if (isNaN(n) || n < 1) n = 1;
    if (n > 10) n = 10;
    if (input) input.value = n;
    link.href = '/cart/' + link.getAttribute('data-variant') + ':' + n + '?storefront=true';
  }

  function initQuantity(root) {
    var wrap = (root || document).querySelector('[data-mt-prepaid-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-mt-qty-input]');
    var minus = wrap.querySelector('[data-mt-qty-minus]');
    var plus = wrap.querySelector('[data-mt-qty-plus]');
    if (!input) return;
    function step(d) {
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = 1;
      input.value = Math.max(1, Math.min(10, n + d));
      syncPrepaid();
    }
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    input.addEventListener('change', syncPrepaid);
    input.addEventListener('blur', syncPrepaid);

    // "Añadir al carrito": agrega el producto y abre el carrito de Shopify.
    // Si algo falla, el propio enlace (cart permalink) sirve de respaldo.
    var link = wrap.querySelector('[data-mt-prepaid]');
    if (link) {
      link.addEventListener('click', function (e) {
        if (link.classList.contains('is-loading')) { e.preventDefault(); return; }
        if (!window.fetch) return;
        e.preventDefault();
        syncPrepaid();
        var n = parseInt(input.value, 10) || 1;
        var cartUrl = link.getAttribute('data-cart-url') || '/cart';
        link.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(link.getAttribute('data-variant')), quantity: n }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = cartUrl;
        }).catch(function () {
          window.location.href = link.href;
        });
      });
    }
  }

  function syncSticky() {
    var bar = document.querySelector('[data-mt-sticky]');
    var main = document.querySelector('[data-mt-submit]');
    if (!bar || !main) return;
    var btn = bar.querySelector('[data-mt-sticky-btn]');
    var price = bar.querySelector('[data-mt-sticky-price]');
    var mainPrice = document.querySelector('[data-mt-price]');
    var stickyCompare = bar.querySelector('[data-mt-sticky-compare]');
    var mainCompareWrap = document.querySelector('[data-mt-compare]');
    btn.textContent = main.textContent.trim();
    btn.disabled = main.disabled;
    if (price && mainPrice) price.textContent = mainPrice.textContent;
    if (stickyCompare && mainCompareWrap) {
      stickyCompare.hidden = mainCompareWrap.hidden;
      var mainCompareText = mainCompareWrap.querySelector('s');
      if (mainCompareText) stickyCompare.textContent = mainCompareText.textContent;
    }
  }

  function initSticky(root) {
    var bar = (root || document).querySelector('[data-mt-sticky]');
    var main = document.querySelector('[data-mt-submit]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-mt-sticky-btn]');
    var pastButton = false, footerVisible = false;
    function render() {
      var on = pastButton && !footerVisible;
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('mt-sticky-on', on);
    }
    btn.addEventListener('click', function () {
      var form = main.form;
      if (form && form.requestSubmit) form.requestSubmit(main); else if (form) form.submit();
    });
    new IntersectionObserver(function (es) {
      var e = es[0];
      pastButton = !e.isIntersecting;
      render();
    }).observe(main);
    var footer = document.querySelector('.mt-footer');
    if (footer) {
      new IntersectionObserver(function (es) { footerVisible = es[0].isIntersecting; render(); }).observe(footer);
    }
  }

  function init(root) {
    initReveal(root);
    initGallery(root);
    initVariants(root);
    initQuantity(root);
    initSticky(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
